import { createAction, createClearAction } from "../../app/createAction";
import {
    INTERNET_CONNECTION_CHANGE,
    INTERNET_CONNECTION_INIT_START,
    INTERNET_CONNECTION_INIT_SUCCESS,
    INTERNET_CONNECTION_MEASURE_SPEED_FAILURE,
    INTERNET_CONNECTION_MEASURE_SPEED_START,
    INTERNET_CONNECTION_MEASURE_SPEED_SUCCESS
} from "./internetConnectionConstants";
import { IInternetConnectionMeasureSpeedSuccessPayload } from "./internetConnection.t";

export const internetConnectionMeasureSpeedStart = () => createClearAction(INTERNET_CONNECTION_MEASURE_SPEED_START);
export const internetConnectionMeasureSpeedSuccess = (payload: IInternetConnectionMeasureSpeedSuccessPayload) =>
    createAction(INTERNET_CONNECTION_MEASURE_SPEED_SUCCESS, payload);
export const internetConnectionMeasureSpeedFailure = (payload?: unknown) =>
    createAction(INTERNET_CONNECTION_MEASURE_SPEED_FAILURE, payload);

export const internetConnectionInitAction = () => createClearAction(INTERNET_CONNECTION_INIT_START);
export const internetConnectionInitSuccess = () => createClearAction(INTERNET_CONNECTION_INIT_SUCCESS);
export const internetConnectionChange = (payload: boolean) => createAction(INTERNET_CONNECTION_CHANGE, payload);

export type IInternetConnectionActionsTypes =
    ReturnType<typeof internetConnectionMeasureSpeedStart> |
    ReturnType<typeof internetConnectionMeasureSpeedSuccess> |
    ReturnType<typeof internetConnectionMeasureSpeedFailure> |
    ReturnType<typeof internetConnectionInitAction> |
    ReturnType<typeof internetConnectionInitSuccess> |
    ReturnType<typeof internetConnectionChange>;
